import script from "./RadioView.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioView.vue?vue&type=script&setup=true&lang=js"

import "./RadioView.vue?vue&type=style&index=0&id=7185ebbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7185ebbc"]])

export default __exports__